var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.31444 -0.00708008L7.90212 5.13074L12.0372 7.10343L7.90212 9.07612L6.31444 14.2139L4.72675 9.07612L0.603516 7.10343L4.72675 5.13074L6.31444 -0.00708008Z",
    fill: "#73C9FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportStar);
export default __webpack_public_path__ + "static/media/report_star.abb4cca798128639b9fe3bd187e828e0.svg";
export { ForwardRef as ReactComponent };